"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@apollo/client/core");
const persisted_queries_1 = require("@apollo/client/link/persisted-queries");
const apollo_link_timeout_1 = __importDefault(require("apollo-link-timeout"));
const crypto_hash_1 = require("crypto-hash");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const timeout = 10000;
const timeoutLink = new apollo_link_timeout_1.default(timeout);
// Cache implementation
const cache = new core_1.InMemoryCache();
let globalApolloClient = null;
function apolloClient(api, linkOptions) {
    // Create a new client for every server-side request so that data
    // isn't shared between connections
    if (typeof window === 'undefined' || (typeof window !== 'undefined' && api)) {
        return createApolloClient(api, linkOptions);
    }
    // Reuse client on the client-side
    if (!globalApolloClient) {
        globalApolloClient = createApolloClient(api, linkOptions);
    }
    return globalApolloClient;
}
function createApolloClient(uri, linkOptions) {
    var _a;
    const isServer = typeof window === 'undefined';
    const useAutomaticPersistedQueries = Boolean((linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.useAutomaticPersistedQueries) && !isServer);
    const useGETAutomaticPersistedQueries = (_a = linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.useGETAutomaticPersistedQueries) !== null && _a !== void 0 ? _a : false;
    const httpLink = new core_1.HttpLink({ uri, fetch: isomorphic_fetch_1.default });
    let timeoutHttpLink;
    if (useAutomaticPersistedQueries) {
        const linkChain = (0, persisted_queries_1.createPersistedQueryLink)({ sha256: crypto_hash_1.sha256, useGETForHashedQueries: useGETAutomaticPersistedQueries }).concat(httpLink);
        timeoutHttpLink = timeoutLink.concat(linkChain);
    }
    else {
        timeoutHttpLink = timeoutLink.concat(httpLink);
    }
    return new core_1.ApolloClient({
        cache,
        ssrMode: typeof window === 'undefined',
        link: timeoutHttpLink,
        defaultOptions: {
            query: {
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
            },
        },
    });
}
exports.default = apolloClient;
//# sourceMappingURL=apolloClient.js.map